export const capitalizeName = (name?: string | null): string => {
	if (!name) return ""
	return name
		.split(" ")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ")
}

export function resolveSenderIdentity({
	senderName,
	companyName,
	fallbackName,
}: {
	senderName?: string | null
	companyName?: string | null
	fallbackName?: string | null
}): { displayName: string; hasKnownSender: boolean } {
	const known = senderName?.trim() || companyName?.trim() || ""
	return {
		displayName: capitalizeName(known || fallbackName),
		hasKnownSender: !!known,
	}
}
